import getStore from '../store';

export default function getPanAndZoom() {
    const { pan, panOffset, zoom, hasDraggedFarEnough } = getStore();
    const { x, y } = pan;
    const isPanning = !!panOffset && hasDraggedFarEnough;
    const { dx, dy } = isPanning ? panOffset! : { dx: 0, dy: 0 };
    return { x: x + dx, y: y + dy, zoom };
}
